"use client";

import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { CORE_COLORS, CORE_FONT } from "@/lib/theme/core";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function CancelLinkedinModal({
  open,
  onOpenChange,
  onConfirm,
}: Props) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/40 backdrop-blur-[2px]" />
        <DialogPrimitive.Content
          className="fixed left-1/2 top-1/2 z-50 flex w-[calc(100vw-32px)] max-w-[380px] -translate-x-1/2 -translate-y-1/2 flex-col gap-[20px] bg-white p-[28px] shadow-xl"
          style={{ borderRadius: "3px" }}
        >
          <div className="flex flex-col gap-[12px]">
            <DialogPrimitive.Title
              style={{
                fontFamily: CORE_FONT.condensed,
                fontSize: "22px",
                fontWeight: 700,
                color: CORE_COLORS.textPrimary,
                lineHeight: 1.15,
                letterSpacing: "-0.2px",
              }}
            >
              取消綁定
            </DialogPrimitive.Title>
            <DialogPrimitive.Description
              style={{
                fontFamily: CORE_FONT.sans,
                fontSize: "14px",
                fontWeight: 400,
                color: CORE_COLORS.textSecondary,
                lineHeight: 1.6,
              }}
            >
              只有《信報》訂戶或綁定 LinkedIn 帳戶才能解鎖留言功能。
            </DialogPrimitive.Description>
          </div>

          <div className="flex items-center gap-[8px]">
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className="inline-flex flex-1 items-center justify-center transition-colors hover:bg-black/[0.04]"
              style={{
                fontFamily: CORE_FONT.sans,
                fontSize: "14px",
                fontWeight: 600,
                color: CORE_COLORS.textPrimary,
                lineHeight: "20px",
                padding: "8px 20px",
                border: `1px solid rgba(0,0,0,0.3)`,
                borderRadius: "3px",
              }}
            >
              取消
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="inline-flex flex-1 items-center justify-center transition-colors hover:bg-[color:var(--red)]/[0.05]"
              style={
                {
                  fontFamily: CORE_FONT.sans,
                  fontSize: "14px",
                  fontWeight: 700,
                  color: CORE_COLORS.brandRed,
                  lineHeight: "20px",
                  padding: "8px 20px",
                  border: `1px solid ${CORE_COLORS.brandRed}`,
                  ["--red" as string]: CORE_COLORS.brandRed,
                  borderRadius: "3px",
                } as React.CSSProperties
              }
            >
              繼續
            </button>
          </div>

          <DialogPrimitive.Close
            aria-label="關閉"
            className="absolute right-[16px] top-[16px] inline-flex size-[28px] items-center justify-center transition-colors hover:bg-black/[0.05]"
            style={{
              border: `1px solid rgba(0,0,0,0.15)`,
              borderRadius: "999px",
            }}
          >
            <X
              className="size-[14px]"
              strokeWidth={2}
              color={CORE_COLORS.textPrimary}
            />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
